import { Link } from "react-router-dom";
import { MapPin, Clock, CurrencyGbp, Users, Calendar } from "@phosphor-icons/react";
import StatusBadge from "@/components/StatusBadge";

export default function JobCard({ job, hrefBase = "/staff/jobs" }) {
  const remaining = Math.max(0, (job.staff_required || 0) - (job.staff_booked || 0));
  return (
    <Link to={`${hrefBase}/${job.id}`} data-testid={`job-card-${job.id}`} className="card-tactile p-5 block">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="min-w-0">
          <div className="label-caps text-blue-600 mb-1">{job.category}</div>
          <h3 className="font-display text-xl font-bold text-slate-900 leading-tight">{job.title}</h3>
          <div className="text-sm text-slate-600 mt-1 truncate">{job.company_name}</div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-display text-2xl font-extrabold text-slate-900">£{Number(job.pay_rate).toFixed(2)}</div>
          <div className="label-caps text-slate-500">/ hour</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 text-sm text-slate-700">
        <div className="flex items-center gap-1.5"><Calendar size={14} /> {job.date}</div>
        <div className="flex items-center gap-1.5"><Clock size={14} /> {job.start_time}–{job.end_time}</div>
        <div className="flex items-center gap-1.5 col-span-2"><MapPin size={14} /> {job.location} {job.postcode ? `· ${job.postcode}` : ""}</div>
      </div>
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100">
        <div className="flex items-center gap-1.5 text-sm text-slate-600"><Users size={14} /> {remaining} position{remaining === 1 ? "" : "s"} left</div>
        <StatusBadge status={job.status} />
      </div>
    </Link>
  );
}
